<template>
    <div class="flex items-center justify-center min-h-screen bg-gray-100">
        <div class="bg-white p-8 rounded shadow-md w-full max-w-sm">
            <h2 class="text-2xl font-semibold mb-6 text-gray-800 text-center">Confirm Sign in</h2>
            <p v-if="isLoading" class="text-gray-600 text-center">Loading...</p>
            <p v-if="errorMessage" class="mt-4 text-red-500 text-center">{{ errorMessage }}</p>
        </div>
    </div>
</template>

<script>
import AuthService from '@/services/auth.service';

export default {
    data() {
        return {
            isLoading: false,
            errorMessage: null,
        };
    },
    mounted() {
        this.confirmLink();
    },
    methods: {
        async confirmLink() {
            this.isLoading = true;
            try {
                await AuthService.confirmSignIn(window.location.href);
                this.$router.push('/dashboard');
            } catch (error) {
                this.errorMessage = error.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>